import React from 'react';
import PropTypes from 'prop-types';

import { IconPrint } from '../../icons/Icons';
import { formatMoney } from '../../../../helpers/moneyHelper';

const propTypes = {
    email: PropTypes.string.isRequired,
    orderID: PropTypes.string.isRequired,
    reservations: PropTypes.array.isRequired,
    subtotal: PropTypes.string.isRequired,
    tax: PropTypes.string.isRequired,
    total: PropTypes.string.isRequired,
    modification: PropTypes.bool.isRequired,
    inventoryComponent: PropTypes.func.isRequired,
    print: PropTypes.func.isRequired
};

export class ConfirmationBox extends React.PureComponent {
    render() {
        const { modification, email, orderID, subtotal, reservations, tax, total, print } = this.props;
        let confirmationTitle = "Thank you for your order!";

        if (modification) {
            confirmationTitle = "We've updated your order!";
        }

        return (
            <div className="rec-order-confirmation-layout">
                <h1>{confirmationTitle}</h1>
                <p className="lead">A confirmation email will be sent out shortly to <strong>{email}</strong></p>
                <div className="rec-order-confirmation-callout">
                    <div className="rec-order-confirmation-callout-body">
                        <div className="rec-order-confirmation-callout-title">Order #: {orderID}</div>
                        <p><a href="/account/reservations">View My Reservations</a></p>
                        <button
                            className="rec-button-primary"
                            title="Continue Shopping"
                            aria-label="Continue Shopping"
                            onClick={() => window.location.assign('/')}>
                            Continue Shopping
                        </button>
                    </div>
                </div>
                <div className="rec-order-confirmation-actions">
                    <button className="rec-button-link" onClick={print}>
                        <IconPrint />
                    </button>
                </div>
                <div className="rec-order-confirmation-details">
                    <div className="rec-order-confirmation-details-header">Reservation Details</div>
                    <div className="rec-order-confirmation-details-body">
                        {
                            reservations.map((reservation, index) => {
                                const key = `reservation-${index}`;
                                return (this.props.inventoryComponent(key, reservation));
                            })
                        }
                        <div className="rec-order-confirmation-details-footer">
                            <div className="rec-order-confirmation-total">
                                <div className="rec-order-confirmation-total-row">
                                    <div className="rec-order-confirmation-total-label">Subtotal:</div>
                                    <div className="rec-order-confirmation-total-value">{formatMoney(subtotal)}</div>
                                </div>
                                <div className="rec-order-confirmation-total-row">
                                    <div className="rec-order-confirmation-total-label">Tax:</div>
                                    <div className="rec-order-confirmation-total-value">{formatMoney(tax)}</div>
                                </div>
                                <div className="rec-order-confirmation-total-row">
                                    <div className="rec-order-confirmation-total-label">Total:</div>
                                    <div className="rec-order-confirmation-total-value"><strong>{formatMoney(total)}</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ConfirmationBox.propTypes = propTypes;

export default ConfirmationBox;
